import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13234150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border rounded-lg overflow-hidden text-textPrimary" }
const _hoisted_2 = {
  class: "overflow-x-auto",
  "data-testid": "management-doctor-table-scroll"
}
const _hoisted_3 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_4 = { class: "bg-gray-50" }
const _hoisted_5 = { class: "bg-white divide-y divide-gray-200 text-sm" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { class: "leading-none" }
const _hoisted_9 = ["data-testid"]
const _hoisted_10 = {
  key: 0,
  class: "action-chip-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-testid": "preview-lock-icon"
}
const _hoisted_11 = ["d"]
const _hoisted_12 = {
  key: 0,
  class: "mt-1 block text-xs text-gray-500"
}
const _hoisted_13 = {
  key: 0,
  class: "flex justify-end border-t border-gray-200 bg-gray-50 px-2 py-1",
  "data-testid": "management-doctor-table-expand-bar"
}
const _hoisted_14 = { class: "w-6 h-6 bg-white border-2 border-primary30 rounded-full flex items-center justify-center" }

import ExpandIcon from '@/assets/icons/expand-icon.vue'
import { mdiAlertCircleOutline, mdiLock } from '@mdi/js'
import { PropType } from 'vue'

interface TableHeader {
  key: string
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementDoctorTable',
  props: {
  headers: {
    type: Array as PropType<TableHeader[]>,
    required: true
  },
  items: {
    type: Array as PropType<any[]>,
    required: true
  },

  expandable: {
    type: Boolean,
    default: false
  }
},
  emits: ['expand'],
  setup(__props) {





// Colunas de texto livre quebram linha; as demais ficam numa linha só (sem corte: o
// wrapper rola na horizontal se ainda assim não couber).
const WRAPPING_CELLS: Record<string, string> = {
  action: 'min-w-[140px] whitespace-normal',
  current: 'min-w-[120px] whitespace-normal'
}
const cellClass = (key: string) => WRAPPING_CELLS[key] ?? 'whitespace-nowrap'

const getAvailabilityClass = (availability: string) => {
  if (availability === 'Conflitante') {
    return 'text-white bg-[#DA1E28] border-[#DA1E28] hover:bg-[#C11B23] active:bg-[#A7171E] inline-flex items-center gap-1'
  }
  if (availability === 'Aberta') return 'bg-orange-100 border-orange-400'
  if (availability === 'Com médico') return 'bg-[#E0F2F6] border-primary10'
  if (availability === 'Ocupado s/ ident.') return 'availability-unidentified border-neutralLight'
  return 'bg-gray-100 border-gray-400'
}

// Chip da ação na cor do estado de DESTINO (mesma paleta dos chips do resumo).
const ACTION_CLASSES: Record<string, string> = {
  doctor: 'action-chip-doctor',
  unidentified: 'action-chip-unidentified',
  open: 'action-chip-open',
  blocked: 'action-chip-blocked',
  none: 'action-chip-none'
}
const getActionClass = (tone: string | undefined) =>
  ACTION_CLASSES[tone ?? 'none'] ?? ACTION_CLASSES.none

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header) => {
              return (_openBlock(), _createElementBlock("th", {
                key: header.key,
                class: "px-3 py-2 text-center text-xs font-bold text-textPrimary uppercase tracking-wider"
              }, _toDisplayString(header.label), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_5, [
          (!__props.items || __props.items.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", {
                  colspan: __props.headers.length,
                  class: "text-center py-4 text-gray-500"
                }, " Nenhum plantão para exibir. ", 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: header.key,
                  class: _normalizeClass(['px-3 py-2 text-center', cellClass(header.key)])
                }, [
                  (header.key === 'availability')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([
                    'px-2 py-1 rounded-md border text-xs',
                    getAvailabilityClass(item.availability)
                  ])
                      }, [
                        (item.availability === 'Conflitante')
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              icon: _unref(mdiAlertCircleOutline),
                              color: 'white',
                              class: "w-5 h-5 shrink-0"
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(item[header.key]), 1)
                      ], 2))
                    : (header.key === 'action')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['action-chip', getActionClass(item.actionTone)]),
                            "data-testid": `preview-action-${index}`
                          }, [
                            (item.actionTone === 'blocked')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                                  _createElementVNode("path", { d: _unref(mdiLock) }, null, 8, _hoisted_11)
                                ]))
                              : _createCommentVNode("", true),
                            _createTextVNode(_toDisplayString(item.actionLabel), 1)
                          ], 10, _hoisted_9),
                          (item.actionNote)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.actionNote), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(item[header.key]), 1)
                        ], 64))
                ], 2))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    (__props.expandable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "flex items-center gap-2 rounded-full px-2 py-1 text-xs font-bold text-primary30 hover:bg-gray-100 transition-colors",
            title: "Expandir tabela",
            "data-testid": "management-doctor-table-expand",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('expand')))
          }, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(ExpandIcon, { class: "w-[10px] h-[10px]" })
            ]),
            _createTextVNode(" Expandir tabela ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})